angular.module('rjmNg.directives').directive "connectionStatus", [
  () ->
    restrict: "E"
    templateUrl: "directive.connectionStatus.html"
    replace: false
    scope: {}
    controllerAs: "view"
    bindToController: true
    controller: [
      "$routeParams"
      "app"
      "$scope"
      "ConnectionMeta"
      "$timeout"
      "Jobs"
      "JOBS"
      "InputConnections"
      "notification"
      "$q"
      "updateService"
      "$url"
      "cloudbiConnectionUtils"
      "connectionUtils"
      "$rootScope"
      (
        $routeParams
        app
        $scope
        ConnectionMeta
        $timeout
        Jobs
        JOBS
        InputConnections
        notification
        $q
        updateService
        $url
        cloudbiConnectionUtils
        connectionUtils
        $rootScope
      ) ->
        view = @
        view.connectionResponses = []
        view.connectionLookup = {}
        view.notification = ""
        view.app = app
        view.failingConnections = []
        view.failingConnectionsNumber = -1

        # full update info
        view.fullUpdateInfo = {}

        clientId = null
        InputConnectionsInstance = null

        getNormalizedStatusResponse = (response) ->
          if response.status? then response else _.values(response)[0]

        view.getConnectionLink = (connectionId) ->
          cloudbiConnectionUtils.getConnectionLink(view.connectionLookup[connectionId])

        getFailingConnections = (responses) ->
          view.failingConnections = responses
            .filter (response) ->
              # for sourcerer jobs we need to get the first object value
              statusResponse = getNormalizedStatusResponse response
              statusResponse?.status in ['FAIL', 'auth_error', 'iapi_error', 'error', 'third_party_error']
            .map (response) ->
              statusResponse = getNormalizedStatusResponse response
              statusResponse.connectionId or statusResponse.connection_id?.toString()


          view.failingConnectionsNumber = view.failingConnections.length
          view.loadingConnectionInformation = !view.fullUpdateInfo.lastCompletedUpdateJobWithDataSyncStartTime

          $rootScope.$broadcast('updateNotificationCount', view.failingConnectionsNumber, view.loadingConnectionInformation)

        showNotFoundErrorMsg = (error, status) ->
          notification.error "Server Error", "An error occurred while attempting to retrieve connection status.", "global"

        populateConnectionInformation = (connections, useCache = true) ->
          # create lookup
          for connection in connections
            view.connectionLookup[connection.meta_id] = connection

          $q.all(
            connections.map (connection) ->
              if connectionUtils.connectionIsDatabase connection
                ConnectionMeta(clientId).status(connection.meta_id, false, useCache)
              else
                Jobs(clientId).getLast([connection.meta_id], JOBS.SOURCES.THIRD_PARTY)
          ).then (responses) ->
            view.connectionResponses = responses
            getFailingConnections(responses)

        isOnDashboard = ->
          return $routeParams.dashId? or $location.$$absUrl.match('dashapp')

        getConnections = (useCache = true) ->
          InputConnectionsInstance.get(true)
            .then((result) ->
              populateConnectionInformation(result, useCache)
            )
            .catch (result) ->
              notification.clearAll()
              notification.error "Server Error", "There was an error when attempting to fetch your connections. Please contact support.", "global"

        $rootScope.$on "updateConnectionStatus", (e) ->
          getConnections(false)

        @$onInit = () ->
          clientId = $routeParams.clientId or app.getClientId()
          InputConnectionsInstance = InputConnections(clientId)
          updateService.get(clientId).then((data) ->
            view.fullUpdateInfo = data
          )
          if app.isAdminUser()
            getConnections()

        return view
    ]
]
